export default "__VITE_ASSET__BE$1nhgk__"